import { Typography } from '@progress/kendo-react-common';

/**
 * CodeSnip component for displaying code snippets safely
 *
 * Uses plain text rendering with React's built-in XSS protection.
 * Safe to use with any content including user-generated code.
 *
 * @param {Object} props - Component props
 * @param {string} props.code - Code string to display (safely rendered as plain text)
 * @example
 * <CodeSnip code="const x = 5; console.log(x);" />
 *
 * @example
 * <CodeSnip code={`
 *   const handleChange = ({ target }) => {
 *     const { name, value } = target;
 *     setData({ ...data, [name]: value });
 *   }
 * `} />
 */
export const CodeSnip = ({ code }) => {
    return (
        <Typography.pre style={{
            backgroundColor: '#f8f9fa',
            border: '1px solid #e9ecef',
            borderRadius: '4px',
            padding: '12px',
            fontFamily: 'Consolas, Monaco, "Courier New", monospace',
            fontSize: '14px',
            lineHeight: '1.5',
            overflow: 'auto',
            whiteSpace: 'pre-wrap'
        }}>
            <Typography.code>{code}</Typography.code>
        </Typography.pre>
    )
}